// Kompakt-Modus-Fundament fuer die Responsive-Anpassung (2026-07-31, siehe
// project_responsive_mobile_20260731-Memo). Heute laufen CSS-Breakpoints
// (styles.css @media) und JS komplett unabhaengig voneinander — das reicht
// fuer reine Style-Anpassungen, aber Hamburgermenue und Werkzeugleisten-
// Akkordeon sind JS-getriebenes Verhalten, nicht nur Optik. Dieses Modul ist
// die einzige Quelle der Wahrheit fuer "sind wir im Kompakt-Modus": eine
// matchMedia-Abfrage, gespiegelt als CSS-Klasse auf <html> (damit auch reine
// CSS-Regeln denselben Zustand nutzen koennen, ohne eigene @media-Schwellen
// zu pflegen) und als Abo-Mechanismus fuer JS-Komponenten, die aktiv auf den
// Wechsel reagieren muessen (z.B. Kartenbreite in der Werkzeugleiste neu
// berechnen).
//
// Schwelle bewusst binaer gehalten (kein separates Tablet-Zwischenstadium,
// wie vom Nutzer gewuenscht) — 800px deckt Handys und Tablet-Hochformat ab,
// waehrend Tablet-Querformat/kleine Laptops weiterhin die bestehende
// 1100px/1400px-Kaskade in styles.css nutzen.

const COMPACT_VIEWPORT_QUERY = '(max-width: 800px)';
const COMPACT_CLASS = 'viewport-compact';

let mediaQueryList = null;
const listeners = new Set();

function applyCompactClass(isCompact) {
  document.documentElement.classList.toggle(COMPACT_CLASS, isCompact);
}

function notifyListeners(isCompact) {
  listeners.forEach(listener => {
    try {
      listener(isCompact);
    } catch (error) {
      console.error('Kompakt-Modus-Listener fehlgeschlagen:', error);
    }
  });
}

function handleMediaChange(event) {
  applyCompactClass(event.matches);
  notifyListeners(event.matches);
}

export function isCompactViewport() {
  return mediaQueryList ? mediaQueryList.matches : window.matchMedia(COMPACT_VIEWPORT_QUERY).matches;
}

// Rueckgabewert ist eine Abmelde-Funktion (`unsubscribe`), analog zu den
// anderen Event-Abo-Mustern in diesem Codebase.
export function onViewportModeChange(listener) {
  if (typeof listener !== 'function') return () => undefined;
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function initViewportMode() {
  if (mediaQueryList) return;
  mediaQueryList = window.matchMedia(COMPACT_VIEWPORT_QUERY);
  applyCompactClass(mediaQueryList.matches);
  mediaQueryList.addEventListener('change', handleMediaChange);
}
